export default "__VITE_ASSET__Dm$x$$JT__"